require("../icons/icons");

// CUSTOM MODULES
import Styleguide from "./modules/Styleguide";
import Layoutgrid from "./modules/Layoutgrid";

import Header from "./modules/Header";
import Heroform from "./modules/Heroform";
import Intro from "./modules/Intro";
import Video from "./modules/Video";
import Cards from "./modules/Cards";
import Toast from "./modules/Toast";
import Team from "./modules/Team";
import Toggle from "./modules/Toggle";
import Filter from "./modules/Filter";

/**
 *  App class
 *
 *  The App class functions a the main back-bone of the javascript used in this
 *  project.
 *
 */

class App {
  /**
   *  Constructor
   */
  constructor() {
    this.onDocumentReady(this.init);
  }

  onDocumentReady(fn) {
    if (
      document.readyState === "complete" ||
      document.readyState === "interactive"
    ) {
      // call on next available tick
      setTimeout(fn, 1);
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  }

  init() {
    new Header();
    new Cards();

    if (document.querySelectorAll("#DonationForm_DonationForm").length) {
      new Heroform();
    }
  }

  handleIntro() {
    new Intro();
  }
  handleStyleguide() {
    new Styleguide();
  }

  handleLayoutgrid(categorySelect = false) {
    new Layoutgrid(categorySelect);
  }

  handleToast(container) {
    new Toast(container);
  }

  handleTeam() {
    new Team();
  }

  handleToggle() {
    const triggers = document.querySelectorAll(".js--toggle");
    new Toggle(triggers);
  }

  handleFilter() {
    new Filter();
  }
}

window.app = new App();
